import { createActions } from "redux-actions";

export const { setCompanyRoles, setCompanyRolesLoading } = createActions({
  SET_COMPANY_ROLES: ({ items }) => ({ items }),
  SET_COMPANY_ROLES_LOADING: ({ loading }) => ({ loading }),
});
